import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Noto Serif', serif`,
    body: `'Noto Sans', sans-serif`,
  },
});

export default theme;
